import ApiConstants from '../../constants/ApiConstants';
import checkResults from './checkResults.js';
import xhr from './xhr';

const CurrentUserApiUtils = {
  fetchTutors() {
    return xhr(ApiConstants.FetchTutors, { method: 'get' }).then(
      (json) => json,
    );
  },

  me() {
    return xhr(ApiConstants.Me).then(checkResults);
  },

  fetchDataForStudentDashboard() {
    return xhr(ApiConstants.Me + 'data/for-student-dashboard');
  },

  fetchDataForTutorDashboard() {
    return xhr(ApiConstants.Me + 'data/for-tutor-dashboard');
  },

  updateStudentProfile(params) {
    return xhr(ApiConstants.UpdateStudentProfile, {
      method: 'put',
      body: JSON.stringify({
        user: params,
      }),
    });
  },

  updateTutorProfile(params) {
    return xhr(ApiConstants.Base + 'users/update-tutor-profile', {
      method: 'put',
      body: JSON.stringify({
        user: {
          user_profile_attributes: {
            bio: params.bio,
          },
        },
      }),
    });
  },

  fetchProfilePhoto() {
    return xhr(ApiConstants.FetchProfilePhoto);
  },

  uploadProfilePhoto(file) {
    return xhr(ApiConstants.UploadProfilePhoto, {
      method: 'post',
      body: JSON.stringify({ file }),
    });
  },

  deleteProfilePhoto() {
    return xhr(ApiConstants.DeleteProfilePhoto, {
      method: 'delete',
    });
  },

  setSkypeId(skype_id) {
    return xhr(ApiConstants.SetSkypeId, {
      method: 'post',
      body: JSON.stringify({
        skype_id,
      }),
    });
  },

  setTeamsContactEmail(teams_contact_email) {
    return xhr(ApiConstants.SetTeamsContactEmail, {
      method: 'post',
      body: JSON.stringify({
        teams_contact_email,
      }),
    });
  },

  getUnseenMessageCount() {
    return xhr(ApiConstants.Me + 'unseen_message_count');
  },

  setUnseenMessageCountToZero() {
    let timestamp = new Date().getTime();
    return xhr(ApiConstants.Me + 'unseen_message_count', {
      method: 'put',
      body: JSON.stringify({
        time: timestamp,
      }),
    });
  },

  deactivate(userId) {
    return xhr(ApiConstants.Base + 'users/' + userId + '/deactivate', {
      method: 'put',
    });
  },

  getDataForEditProfileOfTutor() {
    return xhr(ApiConstants.Me + 'data-for-edit-profile');
  },

  getIcalData(icalId) {
    return xhr(`${ApiConstants.Base}ical-data/${icalId}`);
  },
};

export default CurrentUserApiUtils;
